import { render } from "./YatirimlarSvg.vue?vue&type=template&id=ed67e61c&scoped=true"
import script from "./YatirimlarSvg.vue?vue&type=script&lang=js"
export * from "./YatirimlarSvg.vue?vue&type=script&lang=js"

import "./YatirimlarSvg.vue?vue&type=style&index=0&id=ed67e61c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed67e61c"]])

export default __exports__